import React from 'react';
import { styles } from './styles.js';

const DEFAULT_COLOR_SCHEME = 'light';
function CustomProperties(props) {
  const {
    as: Component = 'div',
    children,
    className,
    colorScheme = DEFAULT_COLOR_SCHEME
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
    // Convenience attribute for locating the stylesheet in the DOM.
    "data-polaris-custom-properties": "",
    dangerouslySetInnerHTML: {
      __html: styles
    }
  }), /*#__PURE__*/React.createElement(Component, {
    "p-color-scheme": colorScheme,
    className: className,
    style: {
      color: 'var(--p-text)'
    }
  }, children));
}

export { CustomProperties, DEFAULT_COLOR_SCHEME };
